import { MeetingInformationItem } from "./MeetingInformationItem";

export default MeetingInformationItem;
